import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import TableCellTypography from 'shared/components/widgets/tabel-cell-typography';
import { bytesToSize } from 'shared/helpers/bytes-to-size';
import TooltipWithTableCellTypography from '../../../shared/components/widgets/tooltip';

export const operationHistoryCustomerDeliveryFilesListColumns: GridColDef[] = [
  {
    field: 'histSeq',
    headerName: 'No', // Number
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 100,
    minWidth: 100,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {params?.row?.id || params?.row?.id === 0 ? params?.row?.id : '--'}
        </TableCellTypography>
      );
    },
  },
  {
    field: 'histDt',
    headerName: '다운로드 일자', // Download Date
    headerAlign: 'left',
    align: 'left',
    flex: 2,
    maxWidth: 260,
    minWidth: 260,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value}</TableCellTypography>;
    },
  },
  {
    field: 'remoteIp',
    headerName: '접속 IP', // Connection IP
    headerAlign: 'left',
    align: 'left',
    flex: 2,
    maxWidth: 240,
    minWidth: 240,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value ?? '--'}</TableCellTypography>;
    },
  },
  {
    field: 'otmSubject',
    headerName: '업로드 제목', // Upload Title
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 280,
    minWidth: 280,
    renderCell: (params: GridRenderCellParams) => {
      return <TooltipWithTableCellTypography value = {params.value} />;
    },
  },
  {
    field: 'fileTotalCnt',
    headerName: '다운로드한 총 파일 수',
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    maxWidth: 190,
    minWidth: 190,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      return <TableCellTypography>{params.value ?? '--'}</TableCellTypography>;
    },
  },
  {
    field: 'fileTotalSize',
    headerName: '파일크기', // File Size
    headerAlign: 'left',
    align: 'left',
    flex: 1,
    sortable: true,
    maxWidth: 132,
    minWidth: 132,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <TableCellTypography>
          {bytesToSize(params.value) ?? '--'}
        </TableCellTypography>
      );
    },
  },
];
